<template>
  <div class="mask" v-if="oks">
   <div class="tops hovers" id="topss">
      <p><span @click="returns()"  >首页</span><span><img src="../assets/you.png" alt=""></span><span class="lastspan">产品 </span></p>
    </div>
    <div class="centers">
      <ul>
        <li @click="intos(1)"  class="hovers">
          <div class="imgs">
            <img src="../assets/home1.png" alt="">
          </div>
        
          <h3>MPODI 病虫神算子</h3>
          <p class="texts">自动采集气象数据并对接模型;用户可自建预测数学模型，共享模型，修改模型，运行数学模型，并根据模版发布病害情报;支持手机APP便捷查看气象数据和运行模型生成结果。</p>
          <div class="btns" >
            <p>了解更多 →</p>
          </div>
        </li>
        <li @click="intos(2)"  class="hovers">
          <div class="imgs">
            <img src="../assets/chanpin2.png" alt="">          
          </div>
          
          <h3>魔蚊特©灭蚊器</h3>
          <p class="texts">这种创新产品可以悄无声息地诱捕并杀死蚊子和其他飞行的害虫。没有刺激性化学物质或强烈气味。 时尚、紧凑和现代的设计也使其成为任何个人或专业空间的完美补充。</p>
          <div class="btns" >
            <p>了解更多 →</p>
          </div></li>
       
      </ul>
     </div>
    </div>
</template>

<script>
  export default {
    data(){
      return{
        oks:true
      }
    },
    methods:{
      returns(){
      this.$router.push({ path: "/" })
    },
    intos(e){
      if(e==1){
        this.$router.push({ path: "/Chanpin1" })
      }
      if(e==2){
        this.$router.push({ path: "/Chanpin2" })
      }
      
    }
    },
    created(){},
    mounted(){}
 }
</script>

<style scoped>
.tops p {
  padding-left: 5%;
  /* background: yellow; */
  box-sizing: border-box;
  padding-top: 1rem;
  padding-bottom:1rem;
  font-size: 0.6rem;
}

.tops p img {
  width: 0.6rem;
}

.tops p span {
  margin-right: 0.8rem;
  /* color: #3b3c3c; */
  color: #9c9c9c;
}

.tops p .lastspan {
  color: #3b3c3c;
}
.centers ul{
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  /* background: pink; */
}
.centers ul li{
  width: 45.5%;
  overflow: hidden;
  /* border: 1px solid red; */
  margin: 3% 0;
  margin-left: 3%;
  /* border: 1px solid red; */
  /* height: 30vh; */
  box-sizing: border-box;
  padding:2rem 3rem;
  /* background: ; */
  box-shadow:0px 0px 3px rgba(0,0,0,0.1);
}
  .centers ul li .imgs{
    height: 32vh;
    display: block;
    margin: auto;
    position: relative;
    /* transform: translate(-50%,-50%); */
  }
  .imgs img{
    height: 100%;
    position: absolute;
    left:50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .centers ul li:hover{
    scale: 1.01;
    box-shadow:0px 0px 3px rgba(0,0,0,0.4);
  }
  .centers h3{
    font-size: 1rem;
    font-weight: bold;
    line-height: 2;

  }
  .centers p{
    font-size: 0.6rem;
    line-height: 1.4;
  }
  .centers .texts{
    margin-top: 1rem;
    margin-bottom: 1rem;
    overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      word-break: break-all;
  }
  .btns{
    border: 1px solid #2180D1;
    display: inline-block;
    padding: 0.4rem 1rem;
  }
  .btns p{
    color: #2180D1;
  }
</style>